import React from 'react';
import { Helmet } from 'react-helmet-async';

const StructuredData: React.FC = () => {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Latant Consulting",
    "url": "https://latantconsulting.com",
    "logo": "https://latantconsulting.com/logo512.png",
    "description": "Expert consulting in Stencil.js, React, Node.js, Angular, Flutter, Ruby on Rails & Python. Specializing in framework-agnostic web components and digital transformation.",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "US"
    },
    "sameAs": [
      "https://github.com/latant-consulting",
      "https://linkedin.com/company/latant-consulting"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "Customer Service",
      "availableLanguage": "English"
    }
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Latant Consulting",
    "url": "https://latantconsulting.com",
    "description": "Complete digital solutions and consulting services",
    "publisher": {
      "@type": "Organization",
      "name": "Latant Consulting"
    }
  };

  const professionalServiceSchema = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "Latant Consulting",
    "image": "https://latantconsulting.com/logo512.png",
    "description": "Full-stack consulting and digital transformation services specializing in modern web technologies",
    "priceRange": "$$",
    "serviceType": [
      "Web Development",
      "Software Consulting",
      "Digital Transformation",
      "Full-Stack Development",
      "Stencil.js Development",
      "React Development",
      "Angular Development",
      "Node.js Development"
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(professionalServiceSchema)}
      </script>
    </Helmet>
  );
};

export default StructuredData;
